import React from 'react';
import {
    EAnnex6V2RecordCode,
    EAnnex6V2RecordState,
    TAnnex6V2BackendRecord,
} from '../../../../../redux/app/annex6-v2/@types';
import Annex6V2GroupA1Preview from '../new-operation/group-operation/previews/Annex6V2GroupA1Preview';
import Annex6V2GroupB1Preview from '../new-operation/group-operation/previews/Annex6V2GroupB1Preview';
import Annex6V2GroupB2Preview from '../new-operation/group-operation/previews/Annex6V2GroupB2Preview';
import Annex6V2GroupB3Preview from '../new-operation/group-operation/previews/Annex6V2GroupB3Preview';
import Annex6V2GroupC1Preview from '../new-operation/group-operation/previews/Annex6V2GroupC1Preview';
import Annex6V2GroupC2Preview from '../new-operation/group-operation/previews/Annex6V2GroupC2Preview';
import Annex6V2GroupC3Preview from '../new-operation/group-operation/previews/Annex6V2GroupC3Preview';
import Annex6V2GroupD1Preview from '../new-operation/group-operation/previews/Annex6V2GroupD1Preview';
import Annex6V2GroupD2Preview from '../new-operation/group-operation/previews/Annex6V2GroupD2Preview';
import Annex6V2GroupE1Preview from '../new-operation/group-operation/previews/Annex6V2GroupE1Preview';
import Annex6V2GroupE2Preview from '../new-operation/group-operation/previews/Annex6V2GroupE2Preview';
import Annex6V2GroupF1Preview from '../new-operation/group-operation/previews/Annex6V2GroupF1Preview';
import Annex6V2GroupG1Preview from '../new-operation/group-operation/previews/Annex6V2GroupG1Preview';
import Annex6V2GroupG2Preview from '../new-operation/group-operation/previews/Annex6V2GroupG2Preview';
import Annex6V2GroupH1Preview from '../new-operation/group-operation/previews/Annex6V2GroupH1Preview';
import Annex6V2GroupH2Preview from '../new-operation/group-operation/previews/Annex6V2GroupH2Preview';
import Annex6V2GroupI1Preview from '../new-operation/group-operation/previews/Annex6V2GroupI1Preview';
import Annex6V2GroupJ1Preview from '../new-operation/group-operation/previews/Annex6V2GroupJ1Preview';
import Annex6V2GroupJ2Preview from '../new-operation/group-operation/previews/Annex6V2GroupJ2Preview';
import Annex6V2GroupK1Preview from '../new-operation/group-operation/previews/Annex6V2GroupK1Preview';
import Annex6V2GroupK2Preview from '../new-operation/group-operation/previews/Annex6V2GroupK2Preview';
import Annex6V2GroupK3Preview from '../new-operation/group-operation/previews/Annex6V2GroupK3Preview';
import Annex6V2GroupK4Preview from '../new-operation/group-operation/previews/Annex6V2GroupK4Preview';
import Annex6V2GroupL1Preview from '../new-operation/group-operation/previews/Annex6V2GroupL1Preview';
import Annex6V2GroupM1Preview from '../new-operation/group-operation/previews/Annex6V2GroupM1Preview';
import Annex6V2GroupM2Preview from '../new-operation/group-operation/previews/Annex6V2GroupM2Preview';
import moment from 'moment';
import Annex6V2TableRows from '../new-operation/_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2BackendRecord;
    theme?: 'light' | 'dark';
};
type Annex6V2PreviewerProps = OwnProps;
function Annex6V2Previewer(props: Annex6V2PreviewerProps) {
    const { annex6V2Record } = props;
    const isStrikedOff =
        annex6V2Record.state === EAnnex6V2RecordState.STRIKED_OFF;

    const isEditOfApprovedRecord = !!annex6V2Record.dateOfApprovedRecordEdit;

    function renderMain() {
        if (isEditOfApprovedRecord) return renderEditedApprovedRecord();
        return renderRecord(annex6V2Record, isStrikedOff);
    }

    function renderEditedApprovedRecord() {
        if (!annex6V2Record.dateOfApprovedRecordEdit) return null;
        return (
            <>
                {renderEditCorrectionLine()}
                {renderRecord(
                    {
                        ...annex6V2Record,
                        selectedDate: annex6V2Record.dateOfApprovedRecordEdit,
                    },
                    isStrikedOff
                )}
                {renderStruckOffVersionOfEdit()}
            </>
        );
    }

    function renderEditCorrectionLine() {
        if (!annex6V2Record.dateOfApprovedRecordEdit) return null;
        const formattedEditDate = moment(
            annex6V2Record.selectedDate,
            'YYYY-MM-DD'
        ).format('DD-MMM-YYYY');

        return (
            <Annex6V2TableRows
                record={annex6V2Record}
                tableRows={[
                    [
                        formattedEditDate,
                        'M2',
                        '-',
                        'ENTRY PERTAINING TO AN EARLIER INCORRECT OPERATIONAL ENTRY',
                    ],
                ]}
                theme={props.theme}
            />
        );
    }

    function renderStruckOffVersionOfEdit() {
        if (!annex6V2Record.editVersions) return null;
        const oldVersionOfRecord = {
            ...annex6V2Record.editVersions[0],
            state: EAnnex6V2RecordState.STRIKED_OFF,
        };
        // @ts-ignore
        return <Annex6V2Previewer annex6V2Record={oldVersionOfRecord} />;
    }

    function renderRecord(
        recordToRender: TAnnex6V2BackendRecord,
        isStrikedOff: boolean = false
    ) {
        switch (recordToRender.recordCode) {
            case EAnnex6V2RecordCode.Annex6V2A1:
                return (
                    <Annex6V2GroupA1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2B1:
                return (
                    <Annex6V2GroupB1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2B2:
                return (
                    <Annex6V2GroupB2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2B3:
                return (
                    <Annex6V2GroupB3Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2C1:
                return (
                    <Annex6V2GroupC1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2C2:
                return (
                    <Annex6V2GroupC2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2C3:
                return (
                    <Annex6V2GroupC3Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2D1:
                return (
                    <Annex6V2GroupD1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2D2:
                return (
                    <Annex6V2GroupD2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2E1:
                return (
                    <Annex6V2GroupE1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2E2:
                return (
                    <Annex6V2GroupE2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2F1:
                return (
                    <Annex6V2GroupF1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2G1:
                return (
                    <Annex6V2GroupG1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2G2:
                return (
                    <Annex6V2GroupG2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2H1:
                return (
                    <Annex6V2GroupH1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2H2:
                return (
                    <Annex6V2GroupH2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2I1:
                return (
                    <Annex6V2GroupI1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2J1:
                return (
                    <Annex6V2GroupJ1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2J2:
                return (
                    <Annex6V2GroupJ2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2K1:
                return (
                    <Annex6V2GroupK1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2K2:
                return (
                    <Annex6V2GroupK2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2K3:
                return (
                    <Annex6V2GroupK3Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2K4:
                return (
                    <Annex6V2GroupK4Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2L1:
                return (
                    <Annex6V2GroupL1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2M1:
                return (
                    <Annex6V2GroupM1Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            case EAnnex6V2RecordCode.Annex6V2M2:
                return (
                    <Annex6V2GroupM2Preview
                        annex6V2Record={recordToRender}
                        isStrikedOff={isStrikedOff}
                        theme={props.theme}
                    />
                );
            default:
                return null;
        }
    }

    return renderMain();
}

export default Annex6V2Previewer;
